<template>
	<div
		:class="['js-accordion__item', {'is-opened': isOpened}]"
		ref="item"
		:style="styleObject"
	>
		<div
			:class="['js-accordion__trigger', triggerClass]"
			@click="triggerClickHandler"
		>
			<slot name="trigger"></slot>
		</div>
		<div
			:class="['js-accordion__content', contentClass]"
			ref="content"
		>
			<slot name="content"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			triggerClass: {
				type: String,
				default: ''
			},
			contentClass: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				isOpened: false,
				styleObject: {
					paddingBottom: 0
				}
			};
		},
		mounted() {
			this.$nextTick(() => {
				window.addEventListener('resize', this.windowResizeHandler);
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.windowResizeHandler);
		},
		methods: {
			countContentHeight() {
				const targetHeight = this.$refs.content.offsetHeight;
				this.styleObject.paddingBottom = targetHeight + 'px';
			},
			windowResizeHandler() {
				this.isOpened && this.countContentHeight();
			},
			triggerClickHandler() {
				if (!this.isOpened) {
					this.countContentHeight();
				} else {
					this.styleObject.paddingBottom = 0;
				}
				this.isOpened = !this.isOpened;
			}
		}
	};
</script>

<style lang="scss" scoped>
	@import "~sass/_variables.scss";

	.js-accordion {
		&__item {
			position: relative;
			overflow: hidden;
			transition: padding-bottom (2 * $ttime);
		}

		&__trigger {
			position: relative;
			z-index: 10;
		}

		&__content {
			position: absolute;
			bottom: 0;
		}
	}
</style>